module.exports = __webpack_public_path__ + "static/media/quadro3.1014ddc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quadro3.png
// module id = 55
// module chunks = 0